import React from "react";

export default function ImageGrid({ items, onOpen }) {
  return (
    <ul className="image-grid">
      {items.map((img) => (
        <li key={img.id} className="image-cell">
          <button
            className="image-frame as-button"
            onClick={() => onOpen(img)}
            aria-label={`View ${img.name || "item"} details`}
          >
            <img src={img.imageUrl} alt={img.name || "item"} loading="lazy" />
          </button>
        </li>
      ))}
    </ul>
  );
}
